export default __webpack_public_path__ + "static/media/pixel_dao_bg.52d78f72.png";